import {Routes} from '@angular/router';
import {AuthenticationGuard, AuthorizationGuard} from '@softline/auth';
import {importProvidersFrom} from '@angular/core';
import {
  ConnectionHttpService,
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_ENTITY_SERVICE,
  SoftlineEntityService,
  StoreModule
} from '@softline/core';
import {RdpLogAppStore, SOFTLINE_FEATURE_RDP_LOG_APP, SOFTLINE_PERMISSION_RDP_LOG} from './rdp-log.shared';
import {RDP_LOG_ENTRY_RESOURCE_PATH} from './rdp-log.api';

export const rdpLogRoutes: Routes = [
  {
    path: 'rdp-log',
    loadComponent: () => import('./pages/rdp-log-app.component').then(o => o.RdpLogAppComponent),
    children: [
      { path: 'search', loadComponent: () => import('./pages/search/search.component').then(o => o.SearchComponent) },
      { path: '', loadComponent: () => import('./pages/rdp-overview/rdp-overview.component').then(o => o.RdpOverviewComponent), pathMatch: 'full'},
      { path: '**', redirectTo: '/rdp-log' },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {permission: SOFTLINE_PERMISSION_RDP_LOG},
    providers: [
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_RDP_LOG_APP,
          feature: RdpLogAppStore.feature,
          providers: [{
            provide: SOFTLINE_STORE_ENTITY_SERVICE,
            useFactory: (service: ConnectionHttpService) => new SoftlineEntityService( service, RDP_LOG_ENTRY_RESOURCE_PATH),
            deps: [SOFTLINE_SERVICE_HTTP]
          }]
        }),
      ),
    ]
  },
];
